import React, { useState, useEffect } from "react";
import NextIcon from "../NextIcon/NextIcon";
import PreviousIcon from "../PreviousIcon/PreviousIcon";
import EndRightIcon from "../EndRightIcon/EndRightIcon";
import EndLeftIcon from "../EndLeftIcon/EndLeftIcon";

import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";

export default function PaginationCommand(props) {
  const [pagination, setPagination] = useState(props.pagination);

  const onChangeStart = (value) => {
    
    if (!isNaN(value)) {
      let start = parseInt(value == "" ? 1 : value)
      let end = pagination.end
      if  (start <= end) {
        setPagination({...pagination, start:start, end:end})
        props.onClickPagination({...pagination, start:start, end:end})
      }
    }
  };

  const onChangeEnd = (value) => {
    if (!isNaN(value)) {
      let start = pagination.start 
      let end = parseInt(value == "" ? 1 : value)
      if  (start <= end) {
        setPagination({...pagination, start:start, end:end})
        props.onClickPagination({...pagination, start:start, end:end})
      }
    }
  };

  const onClickNextOrPrevious = (shift) => {
    let start = pagination.start + shift
    let end = pagination.end + shift
    if (start>= 1 && end <= pagination.size ){
      setPagination({...pagination, start:start, end:end})
      props.onClickPagination({...pagination, start:start, end:end})
    }
  };

  const onClickFirst = () => {
    let start = 1
    let end =  start + (pagination.end - pagination.start) 
    if (end > pagination.end) end = pagination.end
    if (pagination.size > 0  && start <= end) {
    
      setPagination({...pagination, start:start, end:end})
      props.onClickPagination({...pagination, start:start, end:end})
    }
  };

  const onClickLast = () => {
    let end = pagination.size 
    let start = pagination.size - (pagination.end - pagination.start)  
    if (start < pagination.start) start = pagination.start
    if (end > 0 && start <= end) {
     
      setPagination({...pagination, start:start  , end:end})
      props.onClickPagination({...pagination, start:start, end:end})
    }
  };

  
  useEffect(() => {
    setPagination({...pagination, size:props.pagination.size})
  }, [props.pagination.size]);


  return (
    <div
      style={{
        display: "flex",
        height: "30px",
        paddingTop: "2px",
        
      }}>
      <EndLeftIcon onClick={() => onClickFirst()} />
      <PreviousIcon onClick={() => onClickNextOrPrevious(-1)} />
      <div>
        <input
          type="text"
          className="textBox"
          style={{
            width: "100px",
            height: "20px",
            marginTop: "2px",
            marginLeft: "3px",
            textAlign: "center",
            fontSize: "11px",
          }}
          onChange = {(e) => onChangeStart(e.target.value)}
          value={pagination.start}
        />
      </div>
      <div>
        <input
          readOnly
          style={{
            width: "20px",
            height: "20px",
            marginTop: "2px",
            textAlign: "center",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "11px",
          }}
          value="to"
        />
      </div>
      <div>
      <input
          type="text"
          className="textBox"
          style={{
            width: "100px",
            height: "20px",
            marginTop: "2px",
            marginLeft: "3px",
            textAlign: "center",
            fontSize: "11px",
          }}
          onChange = {(e) => onChangeEnd(e.target.value)}
          value={pagination.end}
        />
      </div>
      <div>
        <input
          readOnly
          style={{
            width: "100px",
            height: "20px",
            marginTop: "2px",
            textAlign: "center",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "11px",
          }}
          value={`of ${pagination.size}`}/>
      </div>
      <NextIcon onClick={() => onClickNextOrPrevious(1)} />
      <EndRightIcon onClick={() => onClickLast()} />
    </div>
  );
}
